import { clsx } from 'clsx';
import { LogoWise, LogoWiseInverse, LogoWisePlatform, LogoWisePlatformInverse, LogoFlag, LogoFlagInverse, LogoFlagPlatform, LogoFlagPlatformInverse } from './logo-assets.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

const svgPaths = {
  WISE: LogoWise,
  WISE_BUSINESS: LogoWise,
  WISE_INVERSE: LogoWiseInverse,
  WISE_BUSINESS_INVERSE: LogoWiseInverse,
  WISE_PLATFORM: LogoWisePlatform,
  WISE_PLATFORM_INVERSE: LogoWisePlatformInverse,
  WISE_FLAG: LogoFlag,
  WISE_FLAG_INVERSE: LogoFlagInverse,
  WISE_FLAG_PLATFORM: LogoFlagPlatform,
  WISE_FLAG_PLATFORM_INVERSE: LogoFlagPlatformInverse
};
var LogoType;
(function (LogoType) {
  LogoType["WISE"] = "WISE";
  LogoType["WISE_BUSINESS"] = "WISE_BUSINESS";
  LogoType["WISE_PLATFORM"] = "WISE_PLATFORM";
})(LogoType || (LogoType = {}));
const labelByType = {
  WISE: 'Wise',
  WISE_BUSINESS: 'Wise Business',
  WISE_PLATFORM: 'Wise Platform'
};
function Logo({
  className,
  inverse,
  type = 'WISE'
}) {
  const LogoSm = svgPaths[`WISE_FLAG${type === 'WISE_PLATFORM' ? '_PLATFORM' : ''}${inverse ? '_INVERSE' : ''}`];
  const LogoMd = svgPaths[`${type}${inverse ? '_INVERSE' : ''}`];
  return /*#__PURE__*/jsxs("span", {
    "aria-label": labelByType[type],
    role: "img",
    className: clsx(className, 'np-logo'),
    children: [/*#__PURE__*/jsx(LogoSm, {
      className: "np-logo-svg np-logo-svg--size-sm"
    }), /*#__PURE__*/jsx(LogoMd, {
      className: "np-logo-svg np-logo-svg--size-md"
    })]
  });
}

export { LogoType, Logo as default };
//# sourceMappingURL=Logo.mjs.map
